import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/storage';

firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_APP_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_APP_ID,
});

export const firebaseAuth = firebase.auth();
export const firestore = firebase.firestore();
export const firebaseDB = firebase.database();
export const firebaseStorage = firebase.storage();

export const FIRESTORE_SERVER_TIMESTAMP = firebase.firestore.FieldValue.serverTimestamp();
